<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center" justify="space-between">
					<v-col cols="12" md="2" lg="2" xl="3" class="mx-0 px-0 py-0">
						<v-row class="" justify="start" no-gutters>
						
							<v-col class="">
								<AlternativeAutocompleteOne
                                    :label="'Empresa'"
									:items="serverItems.companies"
                                    :valueInput="selectedCompany"
                                    :loading="loadingCompanies"
									@valueChange="(v) => {selectedCompany = v; selectedOffice = '';  this.getBranchOffices(); index()}"
                                    :sortAsc="true"
								></AlternativeAutocompleteOne>
							</v-col>
						</v-row>
					</v-col>
                    <v-col cols="12" md="2" lg="2" xl="3" class="mx-0 px-0 px-lg-1 py-3 py-lg-0">
						<v-row class="" justify="start" no-gutters>
						
							<v-col class="">
								<AlternativeAutocompleteOne
                                    :label="'Sucursal'"
									:items="serverItems.offices"
                                    :valueInput="selectedOffice"
                                    :loading="loadingOffices"
									@valueChange="(v) => {selectedOffice = v; index()}"
								></AlternativeAutocompleteOne>
							</v-col>
						</v-row>
					</v-col>
                     <v-col cols="12" md="2" lg="2" xl="1" class="mx-0 px-0 py-0">
						<v-row class="" justify="start" no-gutters>
						
							<v-col class="">
								<AlternativeAutocompleteOne
                                    :label="'Estatus'"
									:items="serverItems.estatus"
                                    :valueInput="selectedStatus"
                                    
									@valueChange="(v) => {selectedStatus = v; index()}"
								></AlternativeAutocompleteOne>
							</v-col>
						</v-row>
					</v-col>
					<v-spacer></v-spacer>
                    <v-col cols="12" lg="6" md="6" xl="5">
                        <v-row justify="end">
                            
                            <v-col v-permission="'employees.create'" cols="1" class="mx-0 mr-md-3 mr-lg-0 mr-xl-0 px-1 pl-1 width-fit px-md-1 ">
                                <iconButton :props="createBtnData"></iconButton>
                            </v-col>
                            <v-col cols="1" class="mx-0 mr-md-3 mr-lg-0 mr-xl-0 px-1 pl-1 width-fit text-right">
                                <iconButton
                                    :props="{
                                    hasTooltip:true,
                                    tooltip: 'Buscar',
                                    color:'primary',
                                    height:'35',
                                    color:'primary',
                                    icon:'mdi-magnify',
                                    
                                    click: () => {openModalSearch()}
                                    }"
                                ></iconButton>
                            </v-col>
                            <v-col cols="1" class="mx-0 mr-md-3 mr-lg-0 mr-xl-0 px-1 pl-1 width-fit text-right">
                                <iconButton
                                    :props="{
                                    hasTooltip:true,
                                    tooltip: 'Exportar',
                                    color:'primary',
                                    height:'35',
                                    color:'primary',
                                    icon:'mdi-progress-download',
                                    iconClass: 'flip',
                                    height:'35',
                                    click: () => {openExportModal()}
                                    }"
                                ></iconButton>
                            </v-col>
                            <v-col v-permission="'employees.delete'" cols="1" class="mx-0 mr-md-3 mr-lg-0 mr-xl-0 px-1 pl-1 width-fit text-right">
                                <iconButton
                                    :props="{
                                    hasTooltip:true,
                                    tooltip: 'Dar de baja',
                                    color:'primary',
                                    height:'35',
                                    color:'primary',
                                    icon:'mdi-account-off-outline',
                                    iconClass: 'flip',
                                    height:'35',
                                    click: () => {goToLayoff()}
                                    }"
                                ></iconButton>
                            </v-col>
                        </v-row>
                    </v-col>
                   
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<datatable :props="tableProps" @method_handler="method_handler" class="table-employess">
							<!-- chip documentation item -->
							<template v-slot:[`item.documentation`]="{ item }">
								<v-chip class="chip-employees-index"  dark label :color="getColorDocumentation(item.documentation)" >{{item.documentation[0]}}</v-chip>
							</template> 
							<!--  -->
						</datatable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <!-- SEARCH -->
        <modal :props="modalSearchProps" @modalResponse="method_handler">
            <!-- Body -->
           
            <template slot="cardBody">
				
                <v-row class="mt-1">
                    <v-col class=" pr-0">
                        <textFieldForm
                            ref="searchInput"
                            label="Nombre del colaborador"
                            :valueInput="searchName"
                            :rule="[]"
                            @valueChange="(v) => {searchName = v.trim(); }"
                            @enterPressed="() => {this.search()}"
                        ></textFieldForm>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <primaryButton
						:props="searchModalBtnData"
						></primaryButton>
                    </v-col>

                </v-row>

                <v-row>
					<v-col class="mx-0 px-0">
						<datatable :props="tableSearchProps" @method_handler="method_handler">
							
						</datatable>
					</v-col>
				</v-row>
                    
			</template>
			<!-- Buttons -->
			
		</modal>

        <!-- SHARE  -->
        <modal :props="modalProps" @modalResponse="method_handler">
            <!-- Body -->
           
            <template slot="cardBody" v-if="!loadingLink">
				
                <v-row class="mt-1">
                    <v-col class=" pr-0">
                        <div class="container-input-share">
                            <v-text-field
                            v-on:focus="$event.target.select()" 
                            ref="clone" 
                            class="outside"
                            color="transparent"
                            v-model="shareValueUrl" 
                            hide-details="auto" 
                             outlined
                            dense 
                            readonly
                            
                        ></v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="4">
                        <secondaryButton
						:props="cancelModal"
						></secondaryButton>
                    </v-col>

                </v-row>
                    
			</template>
			<!-- Buttons -->
			<template slot="cardActions" v-if="!loadingLink">
                
				<v-row justify="end">
					
					<v-col cols="4" class="pl-4 mr-2">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>


        <!-- DELETE -->
        <modal :props="modalDeleteProps" @modalResponse="method_handler">
            <template slot="cardBody">
				<p>
                    ESTAS A PUNTO DE DAR DE BAJA A UN COLABORADOR, 
                    ESTO PROVOCARA QUE ESTE DEJE DE SER CONSIDERADO PARA CUALQUIER 
                    FUNCIONALIDAD DEL SISTEMA Y DESAPARECERÁ DE ESTA LISTA. 
                    PARA CONFIRMAR QUE DESEAS ELIMINAR AL COLABORADOR ESCRIBE <span class="font-weight-black">{{confimPlaceholder}}</span> Y HAZ CLIC EN ELIMINAR
                </p>
                <v-row class="mt-1">
                    <v-col class=" pr-0">
                        <div class="container-input-share">
                            <v-text-field
                            
                            
                            class="outside"
                            color="black"
                            v-model="confirmNameInput" 
                            hide-details="auto" 
                            outlined
                            dense
                            :placeholder="confimPlaceholder"
                            
                            
                        ></v-text-field>
                        </div>
                    </v-col>
                   

                </v-row>
                <v-row class="mt-2">
                    <v-col class=" pr-0">
                        <div class="container-input-share">
                            <v-textarea
                            
                            rows="2"
                            class="outside"
                            color="black"
                            v-model="reasonInput" 
                            hide-details="auto" 
                            outlined
                            dense
                            placeholder="MOTIVO DE BAJA"
                            
                            
                        ></v-textarea>
                        </div>
                    </v-col>
                   

                </v-row>
                    
			</template>
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end" >
					<v-col cols="12" sm="3">
						<secondaryButton
						:props="cancelDeleteModal"
						></secondaryButton>
					</v-col>
                    <v-col cols="12" sm="3" v-if="!access" class="mr-sm-4">
						<primaryButton
						:props="acceptDeleteModalFALSE"
						></primaryButton>
					</v-col>
					<v-col cols="12" sm="3" v-if="access" class="mr-sm-4">
						<primaryButton
						:props="acceptDeleteModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>

        <!-- EXPORT -->
        <modal :props="modalExportProps" @modalResponse="method_handler">
            <!-- Body -->
           
            <template slot="cardBody">
				
                <v-row class="mt-1">
                    <v-col class="px-0">
                        <autocompleteOneForm
                            label="EMPRESA"
                            :valueInput="exportBusinessSelected"
                            :rule="[]"
                            :items="serverItems.exportBusinessList"
                            @valueChange="(v) => {exportBusinessSelected = v;}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>
                <v-row class="mt-1">
                    <v-col class="px-0">
                        <autocompleteOneForm
                            label="ESTATUS DEL COLABORADOR"
                            :valueInput="exportStatusSelected"
                            :rule="[]"
                            :items="serverItems.estatus"
                            @valueChange="(v) => {exportStatusSelected = v;}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>
			</template>
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end" >
					<v-col cols="12" sm="3" class="">
						<secondaryButton
                            :props="cancelExportModal"
						></secondaryButton>
					</v-col>
                    
					<v-col cols="12" sm="4"  class="mr-sm-2">
						<primaryButton
						:props="acceptExportModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>


        <!-- RESTORE EMPLOYEE -->
        <modal :props="modalRestoreEmployeeProps" @modalResponse="method_handler">
            <!-- Body -->
           
            <template slot="cardBody">
				
                <v-row class="mt-1">
                    <v-col :class="`${restoreEmployeeOptionSelected == 'NEW' ? 'pb-10':''}`">
                        <autocompleteOneForm
                            label="Contrato"
                            :valueInput="restoreEmployeeOptionSelected"
                            :rule="[]"
                            :items="restoreEmployeeOptions"
                            @valueChange="(v) => {restoreEmployeeOptionSelected = v;}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>
                <v-form ref="restoreForm" v-if="restoreEmployeeOptionSelected == 'NEW'" :key="updateRestoreForm">
                    <div class="font-weight-bold body-2 pb-5 text-center">
                        Contrato:
                    </div>
                    <div>
                        <v-row>
                        <v-col cols="6">
                            <autocompleteOneForm
                                name="p3"
                                label="Empresa"
                                :valueInput="restoreEmployeeForm.company"
                                :rule="rules.company"
                                :items="serverItems.companies"
                                :loading="loadingCompanies"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.company = v;
                                        getLocations(v);
                                        getPositions(v);
                                        restoreEmployeeForm.location = '';
                                    }
                                "
                            ></autocompleteOneForm>
                        </v-col>

                        <v-col>
                            <autocompleteOneForm
                                name="p3"
                                label="Locación"
                                :valueInput="restoreEmployeeForm.branch_office_id"
                                :rule="rules.branch_office_id"
                                :items="serverItems.locations"
                                :loading="loadingLocations"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.branch_office_id = v;
                                        delete serverErrors[
                                            `contract.branch_office_id`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.branch_office_id`]
                                "
                            ></autocompleteOneForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                          <autocompleteOneForm
                              name="p3"
                              label="Departamento"
                              :valueInput="restoreEmployeeForm.department_id"
                              :rule="rules.required"
                              :items="serverItems.departments"
                              :loading="loadingDepartments"
                              @valueChange="
                                  (v) => {
                                      restoreEmployeeForm.department_id = v;
                                      delete serverErrors[
                                          `contract.department_id`
                                      ];
                                  }
                              "
                              :errorMessages="
                                  serverErrors[`contract.department_id`]
                              "
                          ></autocompleteOneForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <datePickerForm
                                name="p3"
                                label="Fecha de ingreso"
                                :valueInput="restoreEmployeeForm.admission_date"
                                :rule="rules.admission_date"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.admission_date = v;
                                        delete serverErrors[
                                            `contract.admission_date`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.admission_date`]
                                "
                            ></datePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <autocompleteOneForm
                                name="p3"
                                label="Tipo de contrato"
                                :valueInput="restoreEmployeeForm.type"
                                :rule="rules.type"
                                :items="serverItems.contactTypes"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.type = v;
                                        delete serverErrors[`contract.type`];
                                    }
                                "
                                :errorMessages="serverErrors[`contract.type`]"
                            ></autocompleteOneForm>
                        </v-col>
                    </v-row>

                    <!-- DATES FOR "PERIODO DE PRUEBA" CONTRACT -->
                    <v-row v-if="restoreEmployeeForm.type == 'PERIODO DE PRUEBA'">
                        <v-col>
                            <datePickerForm
                                name="p3"
                                label="Fecha de inicio del contrato"
                                :valueInput="restoreEmployeeForm.start_date"
                                :rule="rules.start_date"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.start_date = v;
                                        delete serverErrors[
                                            `contract.start_date`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.start_date`]
                                "
                            ></datePickerForm>
                        </v-col>
                        <v-col>
                            <datePickerForm
                                name="p3"
                                label="Fecha de final del contrato"
                                :valueInput="restoreEmployeeForm.end_date"
                                :rule="rules.end_date"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.end_date = v;
                                        delete serverErrors[
                                            `contract.end_date`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.end_date`]
                                "
                            ></datePickerForm>
                        </v-col>
                    </v-row>
                    <!--  -->

                    <v-row>
                        <v-col>
                            <autocompleteOneForm
                                name="p3"
                                label="Modalidad"
                                :valueInput="restoreEmployeeForm.mode"
                                :rule="rules.mode"
                                :items="serverItems.modes"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.mode = v;
                                        delete serverErrors[`contract.mode`];
                                    }
                                "
                                :errorMessages="serverErrors[`contract.mode`]"
                            ></autocompleteOneForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <autocompleteOneForm
                                name="p3"
                                label="Puesto"
                                :valueInput="restoreEmployeeForm.position_id"
                                :rule="rules.position_id"
                                :items="serverItems.positions"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.position_id = v;
                                        delete serverErrors[
                                            `contract.position_id`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.position_id`]
                                "
                            ></autocompleteOneForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <autocompleteOneForm
                                name="p3"
                                label="Periodicidad de pago"
                                :valueInput="restoreEmployeeForm.payroll_type"
                                :rule="rules.payroll_type"
                                :items="serverItems.payroll_types"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.payroll_type = v;
                                        delete serverErrors[
                                            `contract.payroll_type`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.payroll_type`]
                                "
                            ></autocompleteOneForm>
                        </v-col>
                    </v-row>

             
                    <v-row>
                        <v-col>
                            <switchForm
                                name="p3"
                                title="Requiere apoyo para transporte"
                                leftLabel=""
                                rightLabel="Si"
                                :valueInput="restoreEmployeeForm.support_transportation"
                                :rule="rules.support_transportation"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.support_transportation = v;
                                        delete serverErrors[
                                            `support_transportation`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.support_transportation`
                                    ]
                                "
                            ></switchForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <switchForm
                                name="p3"
                                title="Debe registrar horario de comida"
                                leftLabel=""
                                rightLabel="Si"
                                :valueInput="restoreEmployeeForm.meal_schedule"
                                :rule="rules.meal_schedule"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.meal_schedule = v;
                                        delete serverErrors[
                                            `contract.meal_schedule`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.meal_schedule`]
                                "
                            ></switchForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <switchForm
                                name="p3"
                                title="Recibe compensación por horas extra"
                                leftLabel=""
                                rightLabel="Si"
                                :valueInput="restoreEmployeeForm.has_overtime_payment"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.has_overtime_payment = v;
                                        delete serverErrors[
                                            `contract.has_overtime_payment`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.has_overtime_payment`
                                    ]
                                "
                            ></switchForm>
                        </v-col>
                    </v-row>

                    <v-row justify="start">
                        <v-col class="text-left col-md-6">
                            <div class="font-weight-bold body-2">
                                Horarios Laborales
                            </div>
                        </v-col>
                    </v-row>

                    <v-row justify="start">
                        <v-col class="my-0 py-0">
                            <checkboxForm
                                name="p3"
                                label="Repetir de lunes a viernes"
                                :valueInput="restoreEmployeeForm.repeat_schedule"
                                :rule="rules.repeat_schedule"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.repeat_schedule = v;
                                        delete serverErrors[
                                            `contract.repeat_schedule`
                                        ];
                                        this.checkRepeat();
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.repeat_schedule`]
                                "
                            ></checkboxForm>
                        </v-col>
                    </v-row>

                    <v-row class="less-margin mt-5 pt-0">
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario lunes entrada"
                                :valueInput="restoreEmployeeForm.monday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.monday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.monday_schedule_start`
                                        ];
                                        this.checkRepeat();
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.monday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario lunes salida"
                                :valueInput="restoreEmployeeForm.monday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.monday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.monday_schedule_end`
                                        ];
                                        this.checkRepeat();
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.monday_schedule_end`]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario martes entrada"
                                :valueInput="restoreEmployeeForm.tuesday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.tuesday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.tuesday_schedule_start`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.tuesday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario martes salida"
                                :valueInput="restoreEmployeeForm.tuesday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.tuesday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.tuesday_schedule_end`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.tuesday_schedule_end`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario miércoles entrada"
                                :valueInput="restoreEmployeeForm.wednesday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.wednesday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.wednesday_schedule_start`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.wednesday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario miércoles salida"
                                :valueInput="restoreEmployeeForm.wednesday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.wednesday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.wednesday_schedule_end`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.wednesday_schedule_end`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario jueves entrada"
                                :valueInput="restoreEmployeeForm.thursday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.thursday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.thursday_schedule_start`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.thursday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario jueves salida"
                                :valueInput="restoreEmployeeForm.thursday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.thursday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.thursday_schedule_end`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.thursday_schedule_end`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario viernes entrada"
                                :valueInput="restoreEmployeeForm.friday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.friday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.friday_schedule_start`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.friday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario viernes salida"
                                :valueInput="restoreEmployeeForm.friday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.friday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.friday_schedule_end`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.friday_schedule_end`]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario sábado entrada"
                                :valueInput="restoreEmployeeForm.saturday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.saturday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.saturday_schedule_start`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.saturday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario sábado salida"
                                :valueInput="restoreEmployeeForm.saturday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.saturday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.saturday_schedule_end`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.saturday_schedule_end`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <timePickerForm
                                name="p3"
                                label="Horario domingo entrada"
                                :valueInput="restoreEmployeeForm.sunday_schedule_start"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.sunday_schedule_start = v;
                                        delete serverErrors[
                                            `contract.sunday_schedule_start`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[
                                        `contract.sunday_schedule_start`
                                    ]
                                "
                            ></timePickerForm>
                        </v-col>

                        <v-col>
                            <timePickerForm
                                name="p3"
                                label="Horario domingo salida"
                                :valueInput="restoreEmployeeForm.sunday_schedule_end"
                                :rule="[]"
                                @valueChange="
                                    (v) => {
                                        restoreEmployeeForm.sunday_schedule_end = v;
                                        delete serverErrors[
                                            `contract.sunday_schedule_end`
                                        ];
                                    }
                                "
                                :errorMessages="
                                    serverErrors[`contract.sunday_schedule_end`]
                                "
                            ></timePickerForm>
                        </v-col>
                    </v-row>

                   

                    </div>
                    
                </v-form>
                
			</template>
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end" >
					<v-col cols="12" sm="4" class="">
						<secondaryButton
                            :props="cancelRestoreEmployeeModal"
						></secondaryButton>
					</v-col>
                    
					<v-col cols="12" sm="4"  class="mr-sm-2">
						<primaryButton
						:props="acceptRestoreEmployeeModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		
	</div>
</template>
<script>
// import ChipDataTableItem from "../../../components/ChipDataTableItem.vue";
import Utils from '../../../../helpers/Utils';
import PageStateManager from '../../../../helpers/PageStateManager';
export default {
	components: {
    //    'chip-item': ChipDataTableItem
    },
    data(){
		return {
            updateRestoreForm: 432,
            restoreEmployeeOptionSelected: 'RESTORED',
            restoreEmployeeOptions:[
                {text: "RESTAURAR AL COLABORADOR CON SU ÚLTIMO CONTRATO VIGENTE Y CONSERVAR SU ANTIGÜEDAD", value: "RESTORED"},
                {text: "RESTAURAR AL COLABORADOR CON UN NUEVO CONTRATO Y SIN CONSERVAR SU ANTIGÜEDAD", value: "NEW"},
            ],
            restoreEmployeeForm:{
                company: '',
                branch_office_id: '',
                admission_date: '',
                type: '',
                start_date:'',
                end_date: '',
                mode: '',
                position_id: '',
                payroll_type: '',
                fiscal_salary: '',
                integrated_salary: '',
                support_transportation: '',
                mealTimeCheck: '',
                has_overtime_payment: '',
                repeat_schedule: '',
                monday_schedule_start: '',
                monday_schedule_end: '',
                tuesday_schedule_start: '',
                tuesday_schedule_end: '',
                wednesday_schedule_start: '',
                wednesday_schedule_end: '',
                thursday_schedule_start: '',
                thursday_schedule_end: '',
                friday_schedule_start: '',
                friday_schedule_end: '',
                saturday_schedule_start: '',
                saturday_schedule_end: '',
                sunday_schedule_start: '',
                sunday_schedule_end: '',
                department_id: '',
            },
            rules:{
                required: [(v) => !!v || "El campo es requerido"],
                company: [(v) => !!v || "El campo es requerido"],
                branch_office_id: [(v) => !!v || "El campo es requerido"],
                admission_date: [(v) => !!v || "El campo es requerido"],
                type: [(v) => !!v || "El campo es requerido"],
                mode: [(v) => !!v || "El campo es requerido"],
                position_id: [(v) => !!v || "El campo es requerido"],
                payroll_type: [(v) => !!v || "El campo es requerido"],
                fiscal_salary: [
                    (v) => {
                        if (
                            v != null &&
                            !v.toString().match("^[0-9]+(.[0-9]{1,2})?$")
                        )
                            return "Solo números válidos";
                        if (!v) return "El campo es requerido";
                        return true;
                    },
                ],
                integrated_salary: [
                    (v) => {
                        if (
                            v != null &&
                            !v.toString().match("^[0-9]+(.[0-9]{1,2})?$")
                        )
                            return "Solo números válidos";
                        if (!v) return "El campo es requerido";
                        return true;
                    },
                ],

                

                amount: [
                    (v) => {
                        if (v != null && !v.match("^[0-9]+(.[0-9]{1,2})?$"))
                            return "Solo números válidos";
                        if (!v) return "El campo es requerido";
                        try {
                            if (v.trim() == "") return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    },
                ],
            },
            loadingLocations:false,
            loadingDepartments:false,
            loadingPositions:false,
            serverErrors:{},
            exportBusinessSelected: "ALL",
            exportStatusSelected: "ACTIVO",
            searchName: "",
            reasonInput: "",
            confimPlaceholder:"",
            confirmNameInput: "",
            confirmNameRef: "",
            loadingLink: true,
            shareValueUrl:"dfff",
            selectedCompany: PageStateManager.getState(this.$router.history.current.path, 'selectedCompany')??'',
            selectedOffice: PageStateManager.getState(this.$router.history.current.path, 'selectedOffice')??'',
            selectedStatus: PageStateManager.getState(this.$router.history.current.path, 'selectedStatus')??'ACTIVO',
			loadingCompanies: false,
            loadingOffices: false,
			actions: [
                // {
				// 	name: 'Dar de baja',
				// 	icon: {
				// 		color: 'secondary',
				// 		icon: 'mdi-account-off-outline'
				// 	},
				// 	disabled: false,
				// 	type: 'method',   //  method, external, redirect
				// 	action: 'deleteItemModal',
                //     permissions: 'employees.delete'
				// },
                // {
				// 	name: 'Compartir',
				// 	icon: {
				// 		color: 'secondary',
				// 		icon: 'mdi-share-variant-outline'
				// 	},
				// 	disabled: false,
				// 	type: 'method',   //  method, external, redirect
				// 	action: 'openShareModal',
                //     permissions: 'employees.update'
				// },
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/colaboradores/1/edicion',
                    permissions: 'employees.update'
				},
                {
					name: 'Estadísticas',
					icon: {
						color: 'secondary',
						icon: 'mdi-chart-box-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/colaboradores/1/estadisticas',
                    permissions: 'employees.show'
				},
                {
					name: 'Vacaciones',
					icon: {
						color: 'secondary',
						icon: 'mdi-umbrella-beach-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/colaboradores/1/estadisticas',
                    permissions: 'vacations.create'
				},
                {
					name: 'Nueva Eventualidad',
					icon: {
						color: 'secondary',
						icon: 'mdi-text-box-plus-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/colaboradores/1/estadisticas',
                    permissions: 'employees.create'
				},
				
			],
			tableProps: {
				headers: [
                    
				],
				items: [],
				search: '',
				loading: false
			},

            tableSearchProps:{
                headers: [
                    {
						text: 'Colaborador',
						align: 'left small-text-8',
						value: 'name',
						class: 'table-b-border '
					},
					{
						text: 'Empresa',
						align: 'left small-text-8',
						value: 'company',
						class: 'table-b-border small-text-8'
					},
                    {
						text: 'Sucursal',
						align: 'left small-text-8',
						value: 'branch',
						class: 'table-b-border'
					},
                    
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						class: 'table-b-border'
					}
				],
				items: [],
				search: '',
				loading: false,
                elevation: '0',
                itemsPerPageStart: 5,
                
            },
			
			snackbar: {
				visible: false,
				color: '',
				text: '',
				timeout: '-1'
			},
            searchModalBtnData: {
                
                text: "Buscar",
                icon: "",
				to: "",
				block: true,
                click: ()=>{this.search()}
            },
            createBtnData: {
                hasTooltip:true,
                tooltip: 'Nuevo colaborador',
                color:'primary',
                height:'35',
                icon: "mdi-plus",
				to: "EmployeeCreate",
				block: true,
                click: ()=>{}
            },
            eventBtnData:{
                text: "Nueva eventualidad",
                icon: "mdi-text-box-plus-outline",
				to: "EmployeeEventCreate",
				block: true,
                click: ()=>{}
            },

            serverItems: {
                companies: [{text: "Empresa | Grupo Merca", value: "merca"}],
                offices: [],
                estatus: [{text: "ACTIVO", value: "ACTIVO"}, {text: "INACTIVO", value: "INACTIVO"}],
                exportBusinessList: [],
                locations:[],
                departments:[],
                positions:[],
                contactTypes: [
                    { text: "Indeterminado", value: "INDETERMINADO" },
                    { text: "Periodo de prueba", value: "PERIODO DE PRUEBA" },
                ],
                modes: [
                    { text: "Presencial", value: "PRESENCIAL" },
                    { text: "Remota", value: "REMOTA" },
                    { text: "Híbrida", value: "HÍBRIDA" },
                ],
                payroll_types: [
                    { text: "Semanal", value: "SEMANAL" },
                    { text: "Quincenal", value: "QUINCENAL" },
                    { text: "Catorcenal", value: "CATORCENAL" },
                    { text: "Mensual", value: "MENSUAL" },
                ],
            },

            modalRestoreEmployeeProps: {
				visible: false,
				width: '600',
				title: 'Restaurar contrato del colaborador',
				text: '',
				loading: false,
				bottomLineColor: 'primary',
				
			},
            cancelRestoreEmployeeModal: {
                text: "NO, REGRESAR",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalRestoreEmployeeProps.visible = false}
            },
            acceptRestoreEmployeeModal: {
                text: "Restaurar",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                click: ()=>{this.nextStepRestoreEmployee()}
            },


            modalProps: {
				visible: false,
				width: '500',
				title: 'Compartir el cuestionario para actualización de datos',
				text: 'Comparte este enlace con Dulce Ulibarri para invitarle a actualizar su información personal, este enlace tendrá una vigencia de 48 horas',
				loading: false,
				bottomLineColor: 'success',
				
			},
            cancelModal: {
                text: "Copiar Enlace",
                classes: "justi-center",
                icon: "",
				to: "",
				block: true,
				color: 'success',
                
                click: ()=>{this.copy()}
            },
            cancelExportModal: {
                text: "Cancelar",
                classes: "",
                icon: "mdi-close",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.closeExportModal()}
            },
			acceptModal: {
                text: "Aceptar",
                icon: "",
				to: "",
				block: true,
				color: 'success',
				textColor:'white',
                textColorLevel: "5",
                classes: "justi-center",
				loading:false,
                click: ()=>{this.modalProps.visible = false}
            },

            modalDeleteProps: {
				visible: false,
				width: '700',
				title: 'Baja',
				text: '¿Estás seguro de dar de baja?',
				loading: false,
				bottomLineColor: 'error',
				
			},

            modalSearchProps: {
                visible: false,
				width: '800',
				title: 'Buscar Colaborador',
				text: '',
				loading: false,
                hasCloseBtn: true,
				bottomLineColor: 'primary',
            },

            modalExportProps: {
                visible: false,
				width: '600',
				title: 'Exportar lista de colaboradores',
				text: '',
				loading: false,
				bottomLineColor: 'primary',
            },
			
			cancelDeleteModal: {
                text: "NO, REGRESAR",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalDeleteProps.visible = false}
            },
			acceptDeleteModal: {
                text: "Si, dar de baja",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.delete()}
            },
			acceptExportModal: {
                text: "Descargar",
                icon: "mdi-content-save-outline",
				to: "",
				block: true,
				color: 'primary',
				
				loading:false,
                click: ()=>{this.exportEmployees()}
            },
			acceptDeleteModalFALSE: {
                text: "ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                disabled: true,
                click: ()=>{}
            },
		}
	},
    watch: {
        /**
         * Reset values on "type" change
         */
        [`selectedCompany`]: function () {
            console.log(this.selectedCompany)
            PageStateManager.setState(this.$router.history.current.path, 'selectedCompany', this.selectedCompany)
        },
        [`selectedOffice`]: function () {
            console.log(this.selectedOffice)
            PageStateManager.setState(this.$router.history.current.path, 'selectedOffice', this.selectedOffice)
        },
        [`selectedStatus`]: function () {
            PageStateManager.setState(this.$router.history.current.path, 'selectedStatus', this.selectedStatus)
        },
        [`confirmNameInput`]: function () {
            if(this.confirmNameRef.toUpperCase() == this.confirmNameInput.toUpperCase()){
                this.acceptDeleteModal.disabled = false;
            // console.log(this.confirmNameRef, this.confirmNameInput, this.acceptDeleteModal.disabled)
                return;
            }
            this.acceptDeleteModal.disabled = true;
            // console.log(this.confirmNameRef, this.confirmNameInput, this.acceptDeleteModal.disabled)
        },
        
        restoreEmployeeOptionSelected: function(v){
            this.modalRestoreEmployeeProps.width = 850;
            if(v == 'NEW'){
                this.modalRestoreEmployeeProps.width = 900;
            }
        }
    },
    computed: {
        access: function () {
            if(this.confirmNameRef.toUpperCase() == this.confirmNameInput.toUpperCase()){
                
                if(this.reasonInput.trim() != "")
                    return true;
            }
            return false;
        },
    },

	mounted(){
        if(!this.$gates.hasPermission('area_rol_user.show') && !this.$gates.hasPermission('area_manager_rh_manager.show') && this.$gates.hasPermission('management.show')){
            this.$router.push({name: 'EmployeesManagement'});
            return;
        }else
        if(this.$gates.hasPermission('area_rol_user.show') && !this.$gates.hasPermission('area_manager_rh_manager.show')){
            this.$router.push({name: 'EmployeesArea'});
        }else{
            this.initTable();
            this.getCompanies();
        }
		//this.index()
        Utils.updateCurrentEmployeePage(this.$route.name);
	},

    methods: {
        method_handler(object){
			this[object.method_name](object.parameters)
		},
        goToLayoff(){
            this.$router.push({name: 'EmployeesLayoff'});
        },
        initTable(){
            
            this.tableProps.headers = [
                {
                    text: 'No.',
                    align: 'left small-th-employees',
                    value: 'employe_number',
                    class: 'table-b-border white-space-normal small-th-employees'
                },
                {
                    text: 'Nombre',
                    align: 'left small-th-employees',
                    value: 'name',
                    class: 'table-b-border white-space-normal small-th-employees'
                },
                {
                    text: 'Correo',
                    align: 'center small-th-employees',
                    value: 'email',
                    class: 'table-b-border white-space-normal small-th-employees'
                },
                {
                    text: 'Teléfono',
                    align: 'center small-th-employees',
                    value: 'phone',
                    class: 'table-b-border white-space-normal small-th-employees'
                },
                {
                    text: 'Puesto',
                    align: 'center small-th-employees',
                    value: 'position',
                    class: 'table-b-border white-space-normal'
                },
                {
                    text: 'Sucursal',
                    align: 'center small-th-employees',
                    value: 'office',
                    class: 'table-b-border white-space-normal'
                },
                {
                    text: 'Ingreso',
                    align: 'left small-th-employees',
                    value: 'date_i',
                    class: 'table-b-border white-space-normal'
                },
                {
                    text: 'Docs',
                    align: 'center small-th-employees',
                    value: 'documentation',
                    class: 'table-b-border white-space-normal'
                },
                //{
                    //  text: 'Estatus',
                    // align: 'left small-text-8',
                    // value: 'status',
                    //class: 'table-b-border'
                //},
                {
                    text: 'Acciones',
                    width: '10%',
                    align: 'right',
                    sortable: false,
                    value: 'actions',
                    class: 'table-b-border'
                }
            ]
        },
        copy() {
            this.$refs.clone.focus();
            navigator.clipboard.writeText(this.shareValueUrl);
        },
		index() {
			this.tableProps.loading = true;
			//call api
			this.$api.employees.indexByBusiness(this.selectedCompany, this.selectedOffice, this.selectedStatus)
				.then((resp) =>{
					console.log(resp, "employees index");
					this.tableProps.items = resp.data.map((x) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions));

                        x.actions[0].action = { name: 'EmployeeEdit', params: { id: x.id } }
						x.actions[1].action = { name: 'EmployeeStatistic', params: { id: x.id } }
                        x.actions[2].action = { name: 'EmployeeVacationsCreate', params: { id: x.id } }
                        x.actions[3].action = { name: 'EmployeeEventCreate', params: { id: x.id } }
						

                        if(this.selectedStatus == "INACTIVO"){
                            // x.actions[0].disabled = true;
                            x.actions[2].disabled = true;
                            x.actions[3].disabled = true;
                            // x.actions.splice(0, 1); 
                            x.actions.splice(2, 1); 
                            x.actions.splice(2, 1); 

                            x.actions[0].action = { name: 'EmployeesLayoffEdit', params: { id: x.id } }


                            x.actions.push(
                                {
                                    name: 'Restaurar contrato',
                                    icon: {
                                        color: 'secondary',
                                        icon: 'manage_history',
                                        googleType: true
                                    },
                                    disabled: false,
                                    type: 'method',   //  method, external, redirect
                                    action: 'openRestoreEmployeeModal',
                                    permissions: 'employees.update'
                                },
                            );
                        }
						
						
						
						x['parameters'] = { id: x.id, name: x.name};
						x.position = x.current_contract?.position?.name??'';
						x.date_i = Utils.globalDateFormat(x.current_contract?.admission_date);
                        x.office = x.current_contract?.branch_office?.name??'';

						x.documentation = this.checkDocumentation(x.documents);
						// x.status = this.getStatus(x.current_contract.type, x.current_contract.start_date, x.current_contract.end_date);
						
						return x
					});
				})
				.catch((error) =>{
					console.log(error, "error employees index");
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
			//console.log(test);
			
		},

        openRestoreEmployeeModal(parameters)
        {
            this.resetRestoreEmployeeForm();
			this.selectedID = parameters.id;
            this.restoreEmployeeForm.company = this.selectedCompany;
			this.modalRestoreEmployeeProps = {
                ...this.modalRestoreEmployeeProps,
				visible: true,
				width: '850',
				// title: 'Compartir el cuestionario',
				// text: 'Al compartir el cuestionario, este se enviará a todos los colaboradores adscritos a los registros patronales señalados. \n ¿Estás seguro de continuar?',
				loading: false,
				
				
			}
			this.modalRestoreEmployeeProps.visible = true;
            this.getDepartments();
            this.getLocations(this.restoreEmployeeForm.company ?? "");
            this.getPositions(this.restoreEmployeeForm.company ?? "");
			
		},
        resetRestoreEmployeeForm(){
            this.restoreEmployeeOptionSelected = "RESTORED";
            this.restoreEmployeeForm = {
                company: '',
                branch_office_id: '',
                admission_date: '',
                type: '',
                start_date:'',
                end_date: '',
                mode: '',
                position_id: '',
                payroll_type: '',
                fiscal_salary: '',
                integrated_salary: '',
                support_transportation: '',
                mealTimeCheck: '',
                has_overtime_payment: '',
                repeat_schedule: '',
                monday_schedule_start: '',
                monday_schedule_end: '',
                tuesday_schedule_start: '',
                tuesday_schedule_end: '',
                wednesday_schedule_start: '',
                wednesday_schedule_end: '',
                thursday_schedule_start: '',
                thursday_schedule_end: '',
                friday_schedule_start: '',
                friday_schedule_end: '',
                saturday_schedule_start: '',
                saturday_schedule_end: '',
                sunday_schedule_start: '',
                sunday_schedule_end: '',
                department_id: '',
            }
            try {
                this.$refs.restoreForm.reset();
            } catch (error) {
                console.log(error)
            }
        },

        nextStepRestoreEmployee()
        {
            if(this.restoreEmployeeOptionSelected == undefined || this.restoreEmployeeOptionSelected == '')
                return;


            let request = {
                new_contract: false,
            };
            if(this.restoreEmployeeOptionSelected == 'NEW'){
                if(!this.$refs.restoreForm.validate()){
                    this.$store.dispatch('snackbarError', `Formulario no válido`);
                    return;
                }
                console.log(this.selectedID, this.restoreEmployeeOptionSelected);
                request.new_contract = true;
                request['contract'] = this.processRestoreEmployeeRequest(JSON.parse(JSON.stringify(this.restoreEmployeeForm)));
            }


            this.acceptRestoreEmployeeModal.loading = true;
            this.$api.employees.restore(this.selectedID, request)
                .then(() =>{
                    this.$store.dispatch('snackbarSuccess', `Se ha restaurado correctamente`);
                    this.modalRestoreEmployeeProps.visible = false;
                    this.index();
				})
				.catch((error) =>{
					let errors = []
                    switch(error.response.status){
                        case 400: 
                            if(("message" in error.response.data)){
                                Object.keys(error.response.data.message).forEach((x) => {
                                    //this.serverErrors = error.response.data.message;
                                    error.response.data.message[x].forEach((y) => {
                                        this.serverErrors[x] = Utils.deleteWord(x,y);
                                        errors.push(Utils.deleteWord(x,y))
                                    })
                                });
                                this.$store.dispatch('snackbarError', errors.join('.<br>'));
                            }
                        break;
                        
                    }
                    this.updateRestoreForm = this.updateRestoreForm + 1;
				})
				.finally(() => {
                    this.acceptRestoreEmployeeModal.loading = false;
				})
                
            ;

        },
        processRestoreEmployeeRequest(data)
        {
            let newData = {}
            newData.contract = new Object();
            newData.contract["department_id"] = ''+data.department_id;
            newData.contract["admission_date"] = data.admission_date;
            newData.contract["start_date"] = data.start_date;
            newData.contract["end_date"] = data.end_date;
            newData.contract["type"] = data.type;
            newData.contract["mode"] = data.mode;
            newData.contract["payroll_type"] = data.payroll_type;
            newData.contract["fiscal_salary"] = '1'; //data.fiscal_salary;
            newData.contract["integrated_salary"] = '1'; // data.integrated_salary;
            newData.contract["support_transportation"] = data.support_transportation?'true':'false';
            newData.contract["meal_schedule"] = data.meal_schedule?'true':'false';
            newData.contract["has_overtime_payment"] = data.has_overtime_payment?'true':'false';
            if( data.monday_schedule_start != '' &&  data.monday_schedule_start != null)
                newData.contract["monday_schedule_start"] = data.monday_schedule_start;
            if( data.monday_schedule_end != '' &&  data.monday_schedule_end != null)
                newData.contract["monday_schedule_end"] = data.monday_schedule_end;
            if( data.tuesday_schedule_start != '' &&  data.tuesday_schedule_start != null)
                newData.contract["tuesday_schedule_start"] = data.tuesday_schedule_start;
            if( data.tuesday_schedule_end != '' &&  data.tuesday_schedule_end != null)
                newData.contract["tuesday_schedule_end"] = data.tuesday_schedule_end;
            if( data.wednesday_schedule_start != '' &&  data.wednesday_schedule_start != null)
                newData.contract["wednesday_schedule_start"] = data.wednesday_schedule_start;
            if( data.wednesday_schedule_end != '' &&  data.wednesday_schedule_end != null)
                newData.contract["wednesday_schedule_end"] = data.wednesday_schedule_end;
            if( data.thursday_schedule_start != '' &&  data.thursday_schedule_start != null)
                newData.contract["thursday_schedule_start"] = data.thursday_schedule_start;
            if( data.thursday_schedule_end != '' &&  data.thursday_schedule_end != null)
            newData.contract["thursday_schedule_end"] = data.thursday_schedule_end;
            if( data.friday_schedule_start != '' &&  data.friday_schedule_start != null)
                newData.contract["friday_schedule_start"] = data.friday_schedule_start;
            if( data.friday_schedule_end != '' &&  data.friday_schedule_end != null)
                newData.contract["friday_schedule_end"] = data.friday_schedule_end;
            
            if( data.saturday_schedule_start != '' &&  data.saturday_schedule_start != null)
                newData.contract["saturday_schedule_start"] = data.saturday_schedule_start;
            if( data.saturday_schedule_end != '' &&  data.saturday_schedule_end != null)
                newData.contract["saturday_schedule_end"] = data.saturday_schedule_end;
            
            if(data.sunday_schedule_start != '' && data.sunday_schedule_start != null)
                newData.contract["sunday_schedule_start"] = data.sunday_schedule_start;
            if(data.sunday_schedule_end != ''&& data.sunday_schedule_end != null)
                newData.contract["sunday_schedule_end"] = data.sunday_schedule_end;
            
            newData.contract["branch_office_id"] = ''+data.branch_office_id;
            newData.contract["position_id"] = ''+data.position_id;
            newData.contract["repeat_schedule"] = data.repeat_schedule?'true':'false';
            
            if(data.type == 'INDETERMINADO'){
                delete newData.contract['start_date'];
                delete newData.contract['end_date'];
            }
            return newData.contract;
        },
        /**
            Repeat the value in monday to all day inputs
        */
        checkRepeat() {
            if (this.restoreEmployeeForm.repeat_schedule == true) {
                this.restoreEmployeeForm.tuesday_schedule_start =
                    this.restoreEmployeeForm.monday_schedule_start;
                this.restoreEmployeeForm.wednesday_schedule_start =
                    this.restoreEmployeeForm.monday_schedule_start;
                this.restoreEmployeeForm.thursday_schedule_start =
                    this.restoreEmployeeForm.monday_schedule_start;
                this.restoreEmployeeForm.friday_schedule_start =
                    this.restoreEmployeeForm.monday_schedule_start;

                this.restoreEmployeeForm.tuesday_schedule_end =
                    this.restoreEmployeeForm.monday_schedule_end;
                this.restoreEmployeeForm.wednesday_schedule_end =
                    this.restoreEmployeeForm.monday_schedule_end;
                this.restoreEmployeeForm.thursday_schedule_end =
                    this.restoreEmployeeForm.monday_schedule_end;
                this.restoreEmployeeForm.friday_schedule_end =
                    this.restoreEmployeeForm.monday_schedule_end;
            }
        },
        /**
         * Get locations
         */
        getLocations(location = undefined) {
            if (location == "" || location == undefined) return;
            this.loadingLocations = true;
            this.$api.locations
                .getLocationsByBusiness(location)
                .then((resp) => {
                    //console.log(resp, "carga de locaciones", location);
                    this.serverItems.locations = resp.data.map((itm) => {
                        return { value: itm.id, text: itm.name };
                    });
                })
                .catch((error) => {
                    console.log(error, "error desde form employees");
                })
                .finally(() => {
                    this.loadingLocations = false;
                });
        },
        /**
            Get departments from api
        */
        getDepartments()
        {
            this.loadingDepartments = true;
            this.$api.departments.getSelect()
                .then((resp) =>{
                    //console.log(resp, "desde form");
                    this.serverItems.departments = resp.data.map(item => {
                        return {text: item.name, value: item.id }
                    });
                })
                .finally(() => {
                    this.loadingDepartments = false;
                })
            ;
        },
        /**
         * Get positions
        */
        getPositions(location = undefined) {
            if (location == "" || location == undefined) return;
            //console.log('comienza getPositions', location);
            this.loadingPositions = true;
            this.$api.positions
                .getSelectByBussiness(location)
                .then((resp) => {
                    //console.log(resp, "carga positions", location);
                    this.serverItems.positions = resp.data.map((itm) => {
                        return { value: itm.id, text: itm.name };
                    });
                })
                .catch((error) => {
                    console.log(error, "error desde form employees");
                })
                .finally(() => {
                    this.loadingPositions = false;
                });
        },


		getCompanies()
        {
            this.loadingCompanies = true;
            this.$api.user.getUserBusinessSelect()
				.then((resp) =>{
                    
                    //index filter
					this.serverItems.companies = resp.data.map((comp) => {
						return {value: comp.id, text: `${comp.name}`}
					});

                    

					if(this.serverItems.companies.length >= 1){
						if(this.selectedCompany == "")
                            this.selectedCompany = this.serverItems.companies[0].value;
						this.index();
                        this.getBranchOffices();
					}

                    //export filter
                    this.serverItems.exportBusinessList.push({value: "ALL", text: "TODAS"});
                    this.serverItems.exportBusinessList.push(
                        ...resp.data.map((comp) => {
                            return {...comp, value:comp.id, text: `${comp.name}`}
                        })
                    );
					
				})
				.catch((error) =>{
					console.log(error, "error getBusinessSelect");
				})
				.finally(() => {
                    this.loadingCompanies = false;
				})
			;
        },

        getBranchOffices()
        {
            this.serverItems.offices = [];
            this.loadingOffices = true;
            this.$api.locations.getLocationsByBusiness(this.selectedCompany)
                .then((resp) =>{
                    this.serverItems.offices.push({text: "TODAS", value: ""});
                    resp.data.forEach(item => {
                        this.serverItems.offices.push({text: item.name, value: item.id});
                    });
					
					console.log(resp, 99);
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.loadingOffices = false;
				})
                
            ;
        },
		/**
		 * Set color to chip item
		 */
        getColorDocumentation (status) {
            if(status == "Completa")
				return 'success';
			if(status == "Incompleta")
				return 'warning';
        },

		/**
		 * Set status by dates
		 */
		getStatus(contractType = '', startDate, endDate){
			if(endDate == null){
				return 'Activo';
			}
			if(contractType == 'PERIODO DE PRUEBA'){
				const now = new Date();
				now.setHours(0,0,0,0);
				const end = Utils.convertTZ(endDate, 'America/Mexico_city');
				//end.setHours(0,0,0,0);
				// console.log()
				return now <= end ? 'Activo' : 'Inactivo';
			}
			return 'Activo';
		},
		// convertTZ(date, tzString) {
		// 	return new Date((typeof date === "string" ? new Date(date+' 00:00:00') : date).toLocaleString("en-US", {timeZone: tzString}));   
		// },

		/**
		 * check all "mandatory" documentation
		 */
		checkDocumentation(documents){
			if(documents.length == 0)
				return 'Incompleta';

			for (let i = 0; i < documents.length; i++) {
                const doc = documents[i];
                if(doc.required == true && (doc.file_url == "" || doc.file_url == null))
                    return "Incompleta";
            }
			
			return 'Completa';
		},


        openShareModal(parameters)
		{
			this.selectedID = parameters.id;
			this.modalProps = {
                ...this.modalProps,
				visible: true,
				width: '500',
				// title: 'Compartir el cuestionario',
				// text: 'Al compartir el cuestionario, este se enviará a todos los colaboradores adscritos a los registros patronales señalados. \n ¿Estás seguro de continuar?',
				loading: false,
				bottomLineColor: 'success',
				
			}
			this.modalProps.visible = true;
			this.loadingLink = true;
            this.$api.employees.getToken(this.selectedID)
                .then((resp) =>{
                  
					console.log(resp, 99);
                    this.shareValueUrl = `${process.env.VUE_APP_SELF_URL}/update-employee/${resp.data.token}`;
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.loadingLink = false;
				})
                
            ;
		},


        deleteItemModal(parameters){
			this.selectedID = parameters.id;
            console.log(parameters.name)
            this.confirmNameInput = "";
            this.confimPlaceholder = parameters.name.toUpperCase();
            this.confirmNameRef = parameters.name.toUpperCase();
            this.reasonInput = "";
            let msg = ``;
            let color = 'error';
            let title = "BAJA";
            this.acceptDeleteModal.color = 'error';
            this.acceptDeleteModal.disabled = true;
            this.acceptDeleteModal.textColor= 'white';
            this.acceptDeleteModal.text = "ELIMINAR";

            if(this.selectedStatus == "INACTIVO"){
                msg = `¿Estás seguro dar de alta?`
                this.acceptDeleteModal.color = 'primary';
				this.acceptDeleteModal.textColor= 'black';
                this.acceptDeleteModal.text = "Si, dar de alta";
                color = "white";
                title = "Alta"
            }

			this.modalDeleteProps = {
				...this.modalDeleteProps,
				text: msg,
                bottomLineColor: color,
                title
				
			}
			this.modalDeleteProps.visible = true;
			
		},
		delete(){
			this.acceptDeleteModal.loading = true;
			this.$api.employees.changeStatus(this.selectedID, this.reasonInput)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha actualizado su estatus`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				

				this.$store.dispatch('snackbarError', `Error al dar de baja. Intenta de nuevo`);
			})
			.finally(() => {
				this.modalDeleteProps.visible = false;
				this.acceptDeleteModal.loading = false;
			})
		},


        openModalSearch()
        {
            this.tableSearchProps.itemsPerPageStart = 5;
            this.tableSearchProps.items = [];
            this.searchName = "";
            this.modalSearchProps.visible = true;
            setTimeout(() => {
                this.$refs.searchInput.$children[0].focus()
            });
            
        },

        search()
        {
            if(this.searchName.trim() == "")
                return;
            
            this.tableSearchProps.loading = true;
            
            this.$api.employees.search(this.searchName)
				.then((resp) =>{
					this.tableSearchProps.items = resp.data.map((x) => {
						let acts = JSON.parse(JSON.stringify(this.actions))
                        x['actions'] = acts;
						x.actions[0].action = { name: 'EmployeeEdit', params: { id: x.id } }
						x.actions[1].action = { name: 'EmployeeStatistic', params: { id: x.id } }
                        x.actions[2].action = { name: 'EmployeeVacationsCreate', params: { id: x.id } }
                        x.actions[3].action = { name: 'EmployeeEventCreate', params: { id: x.id } }
						
						
						
						x['parameters'] = { id: x.id, name: x.name};

                        x.company = x.current_contract?.branch_office?.company?.name??"";
                        x.branch = x.current_contract?.branch_office.name??"";
						
						return x
					});
				})
				.catch((error) =>{
					console.log(error, "error employees index");
				})
				.finally(() => {
                    this.tableSearchProps.loading = false;
				})
			;
        },

        openExportModal()
        {
            
            this.modalExportProps.visible = true;
            this.exportBusinessSelected = "ALL";
            this.exportStatusSelected = "ACTIVO"
           
            
        },

        closeExportModal()
        {
            this.modalExportProps.visible = false;
        },

        exportEmployees()
        {
            if(this.exportBusinessSelected == "")
                return;
            if(this.exportStatusSelected == "")
                return;

            this.acceptExportModal.loading = true;
            this.$api.employees.exportEmployees(this.exportBusinessSelected, this.exportStatusSelected.toUpperCase())
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `employees_${this.exportBusinessSelected}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.acceptExportModal.loading = false;
                    this.$store.state.loading = false;
                    this.closeExportModal();
                })
            ;

        }

         

    }
}
</script>

<style lang="scss">

    .container-input-share{
        border: 1px solid gray;
    }

    .outside{
        margin-top: -7px !important;
    }

    .justi-center{
        justify-content: center;
    }

    .width-fit{
        max-width: fit-content;
    
    }

    .chip-employees-index{
        min-width: 32px;
        justify-content: center;
    }

  
    
    // @media (max-width: $display-breakpoints-xl)  {
    //     .width-fit{
    //         max-width: fit-content !important;
    
    //     }
    // }

    // @media (max-width: $display-breakpoints-sm)  {
    //     .width-fit{
    //         max-width: unset;
    
    //     }
    // }


    
</style>